export const getCompanyWithRolesAndUsers = /* GraphQL */ `
  query GetCompanyWithRoles($id: ID!, $userStatus: String) {
    getCompany(id: $id) {
      id
      email
      firstName
      lastName
      company
      interviewInfo
      roles {
        items {
          companyID
          id
          name
          workingSession
        }
        nextToken
      }
      interviews {
        nextToken
      }
      users(filter: { status: { eq: $userStatus } }) {
        items {
          id
          role
          firstName
          lastName
          email
          phone
          status
          title
        }
      }
      status
      discovery
      values1
      values2
      createdAt
      updatedAt
    }
  }
`;
export const listCompaniesWithUsers = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        users {
          items {
            id
            # role
            # firstName
            # lastName
            # email
            # phone
            # status
            # title
          }
        }
        id
        email
        firstName
        lastName
        company
        interviewInfo
        values1
        values2
        hasLoggedIn
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompanyData = /* GraphQL */ `
  query GetCompany($id: ID!, $userStatus: String) {
    getCompany(id: $id) {
      id
      group
      company
      interviewInfo
      values1
      values2
      hasLoggedIn
      status
      displayOrder
      createdAt
      updatedAt
      users(filter: { status: { eq: $userStatus } }) {
        items {
          id
          role
          firstName
          lastName
          email
          phone
          status
          title
          companyID
        }
      }
    }
  }
`;

export const getInterviewBuilderData = /* GraphQL */ `
  query GetInterviewBuilderData($id: ID!) {
    getCompany(id: $id) {
      id
      company
      values1
      values2
      interviewBuilderData
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const updateInterviewBuilderData = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      updatedAt
    }
  }
`;

export const getInterviewCount = /* GraphQL */ `
  query SearchInterviews(
    $filter: SearchableInterviewFilterInput
    $sort: [SearchableInterviewSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInterviewAggregationInput]
  ) {
    searchInterviews(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      total
    }
  }
`;

export const getQuestionResponsesByInterviewIdAndStageAndName = /* GraphQL */ `
  query GetQuestionResponsesByInterviewId(
    $interviewId: ID!
    $stage: Stage!
    $interviewerName: String
    $nextToken: String
  ) {
    listQuestionResponses(
      filter: {
        interviewId: { eq: $interviewId }
        stage: { eq: $stage }
        interviewerName: { eq: $interviewerName }
      }
      nextToken: $nextToken
    ) {
      items {
        id
        interviewId
        stage
        rating
        timestamp
        interviewerName
        question
        notes
        order
        subquestionResponses {
          items {
            id
            questionResponseId
            question
            notes
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getQuestionResponseWithSubquestions = /* GraphQL */ `
  query GetQuestionResponse($id: ID!) {
    getQuestionResponse(id: $id) {
      id
      interviewId
      stage
      rating
      timestamp
      interviewerName
      question
      notes
      order
      subquestionResponses {
        items {
          id
          questionResponseId
          question
          notes
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const getInterviewWithAllResponses = /* GraphQL */ `
  query GetInterview($id: ID!) {
    getInterview(id: $id) {
      id
      group
      questions
      interviewInfo
      scheduling
      stage
      companyID
      companyName
      interviewResultData
      questionResponses {
        items {
          id
          interviewId
          stage
          rating
          timestamp
          interviewerName
          question
          notes
          order
          attribute
          attributeResolved
          ai_reasoning
          ai_score
          ai_quotes
          subquestionResponses {
            items {
              id
              questionResponseId
              question
              notes
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      recordings {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const listOrganizationsValues=  `query ListOrganizations(
  $filter: ModelOrganizationFilterInput
  $limit: Int
  $nextToken: String) { 
  listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      values {
        items {
          name
          id
        }
      }
    }
  }
}`;

export const listCompaniesBuilder =  `query ListCompanies(
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String) { 
  listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      company
      interviewBuilderData
      id
    }
  }
}`;

export const getOrganization = /* GraphQL */ `query GetOrganization($id: ID!) {
  getOrganization(id: $id) {
    id
    group
    name
    isPublished
    companyID
    organizationData
    values {
      items {
        id
        name
        description
        organizationID
        behaviors {
          items {
            id
            attributeId
            weight
            order
            attribute {
              id
              name
              definition
              stage
            }
          }
        }
        weight
        status
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}`;

export const updateOrganization = /* GraphQL */ `mutation UpdateOrganization(
  $input: UpdateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  updateOrganization(input: $input, condition: $condition) {
    id
    group
    name
    isPublished
    companyID
    organizationData
    values {
      items {
          id
          name
          description
          organizationID
          behaviors {
            items {
              id
              attributeId
              weight
              order
              attribute {
                id
                name
                definition
                stage
              }
            }
          }
          weight
          status
        }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`

export const getValue = /* GraphQL */ `query GetValue($id: ID!) {
  getValue(id: $id) {
    id
    group
    name
    description
    organizationID
    companyId
    behaviors
    weight
    status
    attributes {
      items {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
        valueAttributesId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`

export const listValues = /* GraphQL */ `query ListValues(
  $filter: ModelValueFilterInput
  $limit: Int
  $nextToken: String
) {
  listValues(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      group
      name
      description
      organizationID
      companyId
      weight
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
`

export const createAttribute = /* GraphQL */ `mutation CreateAttribute(
  $input: CreateAttributeInput!
  $condition: ModelAttributeConditionInput
) {
  createAttribute(input: $input, condition: $condition) {
    id
    companyID
    group
    title
    description
    weight
    questions {
      items {
        questionID
        attributeID
      }
      nextToken
      __typename
    }
    examples {
      text
      score
      __typename
    }
    value {
      id
      group
      name
      description
      organizationID
      companyId
      behaviors
      weight
      status
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    valueAttributesId
    __typename
  }
}
`
export const updateAttribute = /* GraphQL */ `mutation UpdateAttribute(
  $input: UpdateAttributeInput!
  $condition: ModelAttributeConditionInput
) {
  updateAttribute(input: $input, condition: $condition) {
    id
    companyID
    group
    title
    description
    weight
    questions {
      items {
        questionID
        attributeID
      }
      nextToken
      __typename
    }
    examples {
      text
      score
      __typename
    }
    value {
      id
      group
      name
      description
      organizationID
      companyId
      behaviors
      weight
      status
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    valueAttributesId
    __typename
  }
}
`

export const listAttributes = /* GraphQL */ `query ListAttributes(
  $filter: ModelAttributeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAttributes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyID
      group
      title
      description
      weight
      questions {
        items {
          attributeID
          id
          questionID
          question {
            text
            id
          }
        }
      }
      examples {
        text
        score
        __typename
      }
      value {
        id
        group
        name
        description
        organizationID
        companyId
        behaviors
        weight
        status
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      valueAttributesId
      __typename
    }
    nextToken
    __typename
  }
}
`

export const getMeetingsByInterviewId = `query GetMeetingsByInterviewId($int_id: ID!) {
  listMeetings(filter: {interviewId: {eq: $int_id}}) {
    items {
      stage
      id
      meetingAnalysisId
      ai_conclusion_reasoning
      ai_conclusion_next_stage
      ai_conclusion_fit
      ai_conclusion_strong
      ai_conclusion_weak
      ai_agg_score
    }
  }
}
`;

export const getAnalysisById = `query GetAnalysisById($id: ID!) {
  getAnalysis(id: $id) {
    id
    timestamp
    ml_version
    attributeAnalyses {
      items {
        id
        attribute {
          id
          title
          weight
          description
          value {
            name
            description
          }
        }
        questionAnalyses {
          items {
            question {
              id
              text
              stage
            }
            score
            reasoning
            quotes {
              start
              end
              sentence
            }
          }
        }
      }
    }
    questionAnalyses {
      items {
        question {
          id
          text
          stage
        }
        score
        reasoning
        quotes {
          start
          end
          sentence
        }
      }
    }
  }
}
`;

export const getMeetingFilesForInterview = `query GetMeetingFilesForInt($int_id: ID!) {
  listMeetings(filter: {interviewId: {eq: $int_id}}) {
    items {
      id
      startTime
      endTime
      stage
      files {
        intervieweeAudioUrl
        intervieweeTranscriptUrl
        interviewerAudioUrl
        interviewerTranscriptUrl
      }
    }
  }
}
`;
